import { render, staticRenderFns } from "./AIRecommendationsList.htm?vue&type=template&id=61ea7eb4&scoped=true&"
import script from "./AIRecommendationsList.ts?vue&type=script&lang=js&"
export * from "./AIRecommendationsList.ts?vue&type=script&lang=js&"
import style0 from "./AIRecommendationsList.scss?vue&type=style&index=0&id=61ea7eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ea7eb4",
  null
  
)

export default component.exports